import { ApiError } from '@/api/errors';
import { aiOpenapiClient, unwrapResult } from '@/api/openapi-client';
import { authFetch } from '@/auth/token-interceptor';
import { env } from '@/env';
import type { AiVoiceSession } from '@restaurant/api-client';
import { AiVoiceTranscriptionSchema, type AiLocale } from '@restaurant/api-contracts';

export const isRefusal = (error: unknown): error is ApiError =>
  error instanceof ApiError && error.status !== undefined && error.status < 500;

export async function createVoiceSession(
  restaurantId: string,
  locale: AiLocale,
): Promise<AiVoiceSession> {
  return unwrapResult<AiVoiceSession>(
    await aiOpenapiClient.POST('/restaurants/{restaurantId}/ai/voice/session', {
      params: { path: { restaurantId } },
      body: { locale },
    }),
  );
}

export async function transcribeRecording(input: {
  restaurantId: string;
  audio: Blob;
  durationMs: number;
  locale: AiLocale;
}): Promise<string> {
  const form = new FormData();
  form.append('durationMs', String(Math.max(1, Math.round(input.durationMs))));
  form.append('locale', input.locale);
  form.append('file', input.audio, 'voice');
  const response = await authFetch(
    `${env.aiUrl}/restaurants/${input.restaurantId}/ai/voice/transcribe`,
    { method: 'POST', body: form },
  );
  const body: unknown = await response.json().catch(() => null);
  if (!response.ok) throw ApiError.from(body, response.status);
  return AiVoiceTranscriptionSchema.parse(body).text;
}
